
  import Vue, {PropType} from "vue";
  import {JSONEditor} from "@json-editor/json-editor/src/core";
  import DOMPurify from "dompurify";

  window.DOMPurify = DOMPurify;

  export default Vue.extend({
    name: "pwa-json-editor",
    data() {
      return {
        editor: null,
        errors: {} as any,
      };
    },
    props: {
      title: {
        type: String,
        required: false,
        default: '',
      },
      properties: {
        type: String,
        required: false,
        default: null,
      },
      values: {
        type: String,
        required: false,
        default: null,
      },
      onSave: {
        type: Function as PropType<(data: Record<string, any>) => void>,
        required: false,
        default: null,
      },
    },
    mounted(): void {
      if (this.propertiesData) {
        this.initEditor();
      }
    },
    beforeDestroy(): void {
      this.destroyEditor();
    },
    computed: {
      propertiesData(): any {
        let data = null;
        try {
          if (this.properties) {
            data = JSON.parse(this.properties);
          }
        } catch (e) {
          data = null;
        }

        return data;
      },
      valuesData(): any {
        let data = null;
        try {
          if (this.values) {
            data = JSON.parse(this.values);
            if (data.settings) {
              data = data.settings;
            }
          }
        } catch (e) {
          data = null;
        }

        return data;
      },
      hasErrors(): boolean {
        return Object.keys(this.errors).length > 0;
      },
    },
    methods: {
      initEditor() {
        const editor = this.$refs.editor as HTMLElement;

        const options: any = {
          schema: {
            type: "object",
            title: this.title,
            properties: this.propertiesData,
            options: {
              grid_columns: 1 // solo valido para theme grid , bootstrap , aqui no hace nada
            }
          },
          disable_collapse: true,
          disable_edit_json: true,
          disable_properties: true,
          no_additional_properties: true,
          theme: "bootstrap3",
        };

        if (this.valuesData) {
          options.startval = this.valuesData;
        }

        this.editor = new JSONEditor(editor, options);
      },
      getValues() {
        return this.editor.getValue();
      },
      validate(): boolean {
        const errors: any = {};
        const values = this.getValues();
        Object.keys(values).forEach(field => {
          const fieldInput = this.editor.editors[`root.${field}`].input as HTMLElement;
          if (!values[field]) {
            errors[field] = this.$t('58', {field});
            fieldInput.classList.add("is-invalid");
          } else {
            fieldInput.classList.remove("is-invalid");
          }
        });

        this.errors = errors;

        return !this.hasErrors;
      },
      destroyEditor() {
        if (this.editor) {
          this.editor.destroy();
          this.editor = null;
        }
      },
    },
    watch: {
      properties() {
        this.destroyEditor();
        if (this.propertiesData) {
          this.initEditor();
        }
      },
    },
  });
